// import _ from 'lodash';
const LIMIT = 10;
const MAXLIMIT = 1000;

class TNTBypassCodeController {
    /*@ngInject*/
    constructor(Auth, $state, User, UsersService, DateUtil, RouteService, $translate, $q, Modal, BranchService, LocationService, BypassCodeService, SetupService, RouteStopService, $rootScope) {
        this.BranchService = BranchService;
        this.UsersService = UsersService;
        this.DateUtil = DateUtil;
        this.RouteService = RouteService;
        this.LocationService = LocationService;
        this.BypassCodeService = BypassCodeService;
        this.Modal = Modal;
        this.SetupService = SetupService
        this.User = User;
        this.Auth = Auth;
        this.RouteStopService = RouteStopService;
        this.$translate = $translate;
        this.$q = $q;
        this.$state = $state;
        this.$rootScope = $rootScope;

        this.model = {
            generatingCode: false,
            routeId: null,
            branchId: null,
            userId: null,
            locationId: null,
            selectedIssue: null,
            comments: null,
            trackingId: null,
            bypassCode: null,
            supvApproveId: 0,
            canNotScanLocation: false,
            type: null,
            userListObj: {
                userList: [],
                totalRecords: 0
            },
            routeListObj: {
                routeList: [],
                totalRecords: 0
            },
            branchList: [],
            allUsers: [],
            allBypassCodeData: [],
            locationLists: [],
            locationListObj: {
                locationList: [],
                totalRecords: 0
            },
            currentDate: new Date(),
            loading: true,
            bypassCodeList: [],
            totalBypassCode: 0,
            isCoinCheckOut: 0,
            vaultDate: null,
            issueList: [
                {
                    lable: $translate.instant('branch_mgmt.tnt_bypass_code.cant_scan_location'),
                    value: "cant_scan_location"
                },
                {
                    lable: $translate.instant('branch_mgmt.tnt_bypass_code.cant_load_truck'),
                    value: "cant_load_truck"
                },
                {
                    lable: $translate.instant('branch_mgmt.tnt_bypass_code.cant_scan_delivery'),
                    value: "cant_scan_delivery"
                },
                {
                    lable: $translate.instant('branch_mgmt.tnt_bypass_code.skip_delivery'),
                    value: "skip_delivery"
                },
                {
                    lable: $translate.instant('branch_mgmt.tnt_bypass_code.cant_close_atm'),
                    value: "cant_close_atm"
                }
            ],
            bypassCodeTypeMap: {
                cant_scan_location: 'LocationArrival',
                cant_load_truck: 'LoadPickup',
                cant_scan_delivery: 'UnloadDelivery',
                // 'DeliverDelivery'
                skip_delivery: 'SkipDeliveries',
                cant_close_atm: 'CantCloseAtm',
                override_close: 'OverrideClose'
            },
            currentBranch: User.getUser().branchId,
            paginationObj: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            loggedInUserId: User.getUser().id
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/TNT-bypass-code');
    }

    $onInit() {
        this.$q.all([
            this.BranchService.all(null, 0, MAXLIMIT),
            this.loadPermission()
        ])
            .then((data) => {
                this.model.branchList = data[0].results;
                this.getAllBypassCode();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            });
    }

    loadPermission() {
        this.acl = {};
        this.hasACL = {};

        ['branch_mgmt_tnt_bypass_code'].forEach((permissionKey) => {
            this.acl[permissionKey] = this.User.getACL(permissionKey);
            this.acl[permissionKey].forEach((permission) => {
                this.hasACL[permission] = true;
            });
        });
    }

    branchChanged() {
        this.model.routeId = null;
        this.model.locationId = null;
        this.model.userId = null;
        this.model.locationListObj.locationList = [];
        this.model.locationListObj.totalRecords = 0;
        this.model.paginationObj.page = 1;

        this.SetupService.get(this.model.branchId)
            .then((setup) => {
                const currentVaultDate = this.DateUtil.convertToDate(setup.currentVaultDate);
                const formattedDate = moment(currentVaultDate).format('YYYY-MM-DD');
                this.model.vaultDate = formattedDate;
                this.model.isCoinCheckOut = setup.coinCheckOut;
            })
            .then(() => {
                this.getAllBypassCode();
                this.getRouteData();
                this.getAllLocation('', 0);
                this.getAllUsers('', 0);
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal('error.' + err.data.message);
                }
            });
    }

    locationListSearchObj(searchKey) {
        searchKey = searchKey || '';

        const searchObj = {
            queryJSON: {
                rules: [{
                    field: "branchId",
                    condition: "=",
                    data: this.model.branchId
                },
                {
                    group: {
                        rules: [{
                            field: "locationType",
                            condition: "=",
                            data: "REGULAR"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "NO_SHIP_NO_GO"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "ATM"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "BANK"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "ON_CALL"
                        }
                        ],
                        operator: "OR"
                    }
                },
                {
                    group: {
                        rules: [{
                            field: "id",
                            condition: "like",
                            data: "%" + searchKey + "%"
                        },
                        {
                            field: "name",
                            condition: "like",
                            data: "%" + searchKey + "%"
                        }
                        ],
                        operator: "OR"
                    }
                }],
                operator: "AND"
            }
        }

        if (this.model.selectedIssue === 'cant_scan_delivery' || this.model.selectedIssue === 'skip_delivery') {
            searchObj.queryJSON.rules[1].group.rules.push({
                field: "locationType",
                condition: "=",
                data: "DELIVERY"
            });
        }

        if (this.model.selectedIssue === 'cant_close_atm' || this.model.selectedIssue === 'override_close') {
            searchObj.queryJSON.rules[1].group.rules = [];
            searchObj.queryJSON.rules[1].group.rules.push({
                field: "locationType",
                condition: "=",
                data: "ATM"
            });
        }

        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    getAllLocation(searchKey, offset) {
        searchKey = searchKey || '';

        if (this.model.selectedIssue !== 'cant_load_truck') {
            this.LocationService.getAllLocation(this.locationListSearchObj(searchKey), offset, LIMIT)
                .then((data) => {
                    if (offset === 0 || offset == undefined) {
                        this.model.locationListObj.totalRecords = data.total;
                        this.model.locationListObj.locationList = this.locationListMap(data.results);
                    }
                    else {
                        const locations = this.locationListMap(data.results);
                        this.model.locationListObj.locationList = this.model.locationListObj.locationList.concat(locations);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                });
        }
        else {
            if (this.model.routeId) return this.getRouteStops(searchKey, offset);
        }
    }

    locationListMap(locations) {
        return locations.map((l) => {
            return {
                Key: l.id + " | " + l.name,
                Value: l.id,
                Obj: l
            }
        });
    }

    loadData() {
        if (this.model.branchId !== null) {
            this.model.locationId = "";
            this.getAllLocation('', 0);
        }
    }

    userListSearchObj(searchKey) {
        searchKey = searchKey || '';

        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: 'downloadToHHT',
                                    condition: '=',
                                    data: true
                                },
                                {
                                    field: 'email',
                                    condition: '!=',
                                    data: null
                                },
                                {
                                    field: 'supervisor',
                                    condition: '=',
                                    data: true
                                },
                                {
                                    field: 'serviceUser',
                                    condition: '=',
                                    data: true
                                },
                                {
                                    field: 'customerUser',
                                    condition: '=',
                                    data: true
                                }
                            ],
                            operator: "OR"
                        }
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: "id",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "firstName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "lastName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    getAllUsers(searchKey, offset) {
        searchKey = searchKey || '';

        this.UsersService.all(this.userListSearchObj(searchKey), offset, LIMIT)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.userListObj.totalRecords = data.total;
                    this.model.userListObj.userList = this.userListMap(data.results);
                }
                else {
                    const users = this.userListMap(data.results);
                    this.model.userListObj.userList = this.model.userListObj.userList.concat(users)
                }
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            });
    }

    userListMap(users) {
        return users.map((u) => {
            return {
                Key: u.id + " | " + u.firstName + " " + u.lastName,
                Value: u.id
            }
        });
    }

    routeStopSearchObj(searchKey) {
        searchKey = searchKey || '';

        const searchObj = {
            queryJSON: {
                rules: [{
                    field: "routeId",
                    condition: "=",
                    data: this.model.routeId.Value
                },
                {
                    field: "routeDate",
                    condition: "=",
                    data: this.model.vaultDate
                },
                {
                    group: {
                        rules: [{
                            field: "locationId",
                            condition: "like",
                            data: "%" + searchKey + "%"
                        }],
                        operator: "OR"
                    }
                }
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    getRouteStops(searchKey, offset) {
        searchKey = searchKey || null;

        this.RouteStopService.all(this.routeStopSearchObj(searchKey), offset, LIMIT)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.locationListObj.totalRecords = data.total;
                    this.model.locationListObj.locationList = this.locationMap(data.results);
                }
                else {
                    const locations = this.locationMap(data.results);
                    this.model.locationListObj.locationList = this.model.locationListObj.locationList.concat(locations);
                }
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            });
    }

    locationMap(data) {
        return data.map((d) => {
            return {
                Key: d.location.id + " | " + d.location.name,
                Value: d.location.id
            }
        });
    }

    getRouteData() {
        this.BranchService.getReleaseRoutes(this.model.branchId, this.model.vaultDate, this.model.isCoinCheckOut)
            .then((data) => {
                this.model.routeListObj.routeList = this.routeListMap(data);
                this.model.routeListObj.totalRecords = data.length;
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            });
    }

    routeListMap(routes) {
        return routes.map((r) => {
            return {
                Key: r.routeId + " | " + r.routeName,
                Value: r.routeId
            }
        });
    }

    confirmSupervisor() {
        if (this.isLoading) return;
        this.isLoading = true;

        let allPromise = [], errors = '';

        this.Modal.confirmSupervisor('generate-bypass-code', null, ({ modal, supId }) => {
            this.model.supvApproveId = supId;

            if (this.hasACL.overrideClose && this.model.selectedIssue === 'cant_close_atm') {
                allPromise.push(this.closeLock());

                this.$q.all(allPromise)
                    .then(([results]) => {
                        if (results && results.data && results.data.length > 0) {
                            if (results.data[0].result === 0) {
                                this.generateBypassCode();
                            }
                            else if (results.data[0].result === 1) {
                                if (this.hasACL && this.hasACL.overrideClose) {
                                    const issueExists = this.model.issueList.some(issue => issue.value === 'override_close');
                                    if (!issueExists) {
                                        this.model.issueList.push({
                                            lable: this.$translate.instant('branch_mgmt.tnt_bypass_code.override_close'),
                                            value: "override_close"
                                        })
                                    }
                                }
                                errors += results.data[0].message;
                                errors += '\n------- (If the lock doesn\'t close, you can generate a bypass code using the "Override Close" option.)';
                                this.Modal.errorModal(errors);
                            }
                        }
                    })
                    .catch((err) => {
                        this.Modal.errorModal(err)
                    })
                    .finally(() => {
                        modal.close();
                        this.isLoading = false;
                    })
            }
            else {
                modal.close();
                this.generateBypassCode();
            }
        }, ({ modal }) => {
            if (modal) modal.close();
            this.isLoading = false;
        })
    }

    bypassCodeSearchObj() {
        const searchObj = {
            queryJSON: {
                rules: [{
                    field: 'branchId',
                    condition: '=',
                    data: this.model.branchId ? this.model.branchId : this.model.currentBranch
                }],
                operator: 'AND'
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    getAllBypassCode() {
        this.model.loading = true;

        this.BypassCodeService.all(this.bypassCodeSearchObj(), (this.model.paginationObj.page - 1) * this.model.paginationObj.pageLimit, this.model.paginationObj.pageLimit)
            .then((data) => {
                this.model.bypassCodeList = data.results;
                this.model.totalBypassCode = data.total;
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    reset() {
        if (this.model.selectedIssue && this.model.selectedIssue === 'override_close') {
            this.model.issueList = this.model.issueList.filter(d => d.value !== 'override_close');
        }
        this.model.routeId = null;
        this.model.userId = null;
        this.model.locationId = null;
        this.model.comments = null;
        this.model.trackingId = null;
        // this.model.bypassCode = null;
        this.model.supvApproveId = 0;
        this.model.selectedIssue = null;
        this.model.locationListObj.locationList = [];
        this.model.locationListObj.totalRecords = 0;
        this.model.paginationObj.page = 1;
        this.model.closeCode = null;

    }

    resetLocationObj() {
        if (this.model.selectedIssue === 'cant_load_truck' && !this.model.routeId) {
            this.model.locationListObj.locationList = [];
            this.model.locationListObj.totalRecords = 0;
        }
        this.model.closeCode = null;
    }

    getRouteStopList() {
        if (this.model.selectedIssue === 'cant_load_truck' && this.model.routeId) {
            return this.getRouteStops('', 0);
        }
    }

    createBypassCode() {
        const type = this.model.selectedIssue;
        const branchId = this.model.branchId;
        const routeId = this.model.routeId.Value;
        const userId = this.model.userId.Value;
        const locationId = this.model.locationId.Value;
        const comments = this.model.comments;
        const bypassCode = this.model.bypassCode;
        const supvApproveId = this.model.supvApproveId;

        this.BypassCodeService.create({ type, branchId, routeId, userId, locationId, comments, bypassCode, supvApproveId })
            .then((data) => {
                this.reset();
                this.getAllBypassCode();
            })
            .catch((err) => {
                const errorCode = err && err.data && err.data.message;
                if (errorCode) {
                    if (err.data.errors[0].path === 'bypasscode_tracking_id_unique') {
                        this.bypassCodeThrowError = this.$translate.instant('error.trackingIdUnique');
                    } else {
                        this.bypassCodeThrowError = this.$translate.instant('error.bypassCodeNotGenerate');
                    }
                    this.Modal.errorModal(this.bypassCodeThrowError);
                }
                else {
                    console.log(err);
                }
            })
            .finally(() => {
                this.isLoading = false;
            })
    }

    generateBypassCode() {
        this.model.generatingCode = true;

        const type = this.model.bypassCodeTypeMap[this.model.selectedIssue];
        const branchId = this.model.branchId;
        const routeId = this.model.routeId.Value;
        const userId = this.model.userId.Value;
        const locationId = this.model.locationId.Value;
        const vaultDate = this.model.vaultDate;

        this.BypassCodeService.generateBypassCode(type, branchId, routeId, userId, vaultDate, locationId)
            .then((data) => {
                this.model.bypassCode = data.code;
                this.createBypassCode();
            })
            .catch((err) => {
                console.log(err);
                this.isLoading = false;
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.generatingCode = false;
            })
    }

    pageChange() {
        this.getAllBypassCode();
    }

    translateIssue(message) {
        if (!message || message === 'Location') return;
        return this.$translate.instant(`branch_mgmt.tnt_bypass_code.${message}`);
    }

    closeLock() {
        const branchId = this.model.branchId;
        const userId = this.model.userId.Value;
        const locationId = this.model.locationId.Value;
        const OTCCompanyName = this.model.locationId.Obj.OTCCompanyName;
        const closecode = this.model.closeCode;
        const locktype = this.model.locationId.Obj.lockType;

        const data = { userId: userId, company: OTCCompanyName, serno: locationId, closecode, empid: userId, locktype, branchId };
        return this.BypassCodeService.closeLock(data)
            .then((results) => {
                return results
            })
            .catch((err) => {
                if(err && err.data && err.data.message){
                    this.Modal.errorModal(err.data.message)
                }
            })
    }
}

export default TNTBypassCodeController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/tnt_bypass_code/tnt_bypass_code.controller.js